// @flow
import * as React from "react";
import moment from "moment";
import styled from "styled-components";
import { News as _News, Timestamp } from "./Item";
import { rtl, fontSize } from "../common/styled-mixins";

const News = styled(_News)`
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  flex-shrink: 1;
`;

const Sidebar = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-flow: row wrap;
  align-content: center;
  justify-content: center;
  align-items: flex-start;
  width: 90px;
  ${rtl("margin-left", "14px")};
`;

const Icon = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 11px;
`;

const Title = styled.div`
  margin-bottom: 16px;
  font-weight: 700;
  font-size: ${fontSize(14)};
  line-height: 1.2;
  text-decoration: none;
  color: ${({ theme }) => theme.indexMajor};
`;

const Info = styled.div`
  flex-grow: 1;
  font-size: ${fontSize(12)};
  line-height: 1.5;
  color: ${({ theme }) => theme.textMuted};
`;

const Action = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
  width: 100%;
  min-height: 33px;
  margin-top: auto;
  font-size: ${fontSize(12)};
  line-height: 1.5;
`;

type Props = {
  timestamp: number,
  icon: React.Node,
  action?: React.Node,
  title?: React.Node,
  children?: React.Node,
  details?: React.Node
};

const ItemInfo = ({
  icon,
  action,
  title,
  children,
  details,
  timestamp
}: Props) => (
  <News>
    <Content>
      <Timestamp>{moment.unix(timestamp).format("lll")}</Timestamp>
      <Title>{title}</Title>
      <Info>{children}</Info>
      {details && <Action>{details}</Action>}
    </Content>
    <Sidebar>
      <Icon>{icon}</Icon>
      <Action>{action}</Action>
    </Sidebar>
  </News>
);

export default ItemInfo;



// WEBPACK FOOTER //
// ./src/components/Bell/ItemInfo.js